<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-share-internal`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M9 36a1 1 0 011 1v3h28v-3a1 1 0 011-1h2a1 1 0 011 1v5a2 2 0 01-2 2H8a2 2 0 01-2-2v-5a1 1 0 011-1h2zM32.613 3.31l.094.083 9.9 9.9a1 1 0 01.083 1.32l-.083.094-9.9 9.9a1 1 0 01-1.32.083l-.094-.083-1.414-1.415a1 1 0 01-.084-1.32l.084-.094 5.776-5.777-.497.003c-5.734.073-10.308 1.163-14.166 3.263-3.796 2.068-6.753 5.078-8.783 8.944a24.502 24.502 0 00-.905 1.92l-.112.277c-.1.253-.218.564-.351.933A1 1 0 019.9 32H7.777a1 1 0 01-.95-1.31l.106-.319a28.914 28.914 0 011.747-4.047c2.403-4.563 5.928-8.144 10.42-10.584 4.465-2.426 9.796-3.725 16.556-3.74l-5.778-5.778a1 1 0 01-.084-1.32l.084-.094 1.414-1.415a1 1 0 011.218-.152l.102.07z"/></svg>
</template>
<script>

export default {
  name: 'IconShareInternal',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
